export default "__VITE_ASSET__89b12d71__"